import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import Api from "../../services/Api";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faEdit, faHashtag, faTimes } from '@fortawesome/free-solid-svg-icons';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        arrayResultado: [],
        departamentos: [],
        municipios: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state.arrayResultado;
        state[e.target.name] = e.target.value;
        this.setState({ arrayResultado: state });
    };
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const NOMBRE = document.getElementById('NOMBRE').value;
        const NIT_CONTRIBUYENTE = document.getElementById('NIT_CONTRIBUYENTE').value;
        const ID_DEPARTAMENTO = document.getElementById('ID_DEPARTAMENTO').value;
        const ID_MUNICIPIO = document.getElementById('ID_MUNICIPIO').value;
        const DIRECCION_CONTRIBUYENTE = document.getElementById('DIRECCION_CONTRIBUYENTE').value;
        const CORREO_ELECTRONICO = document.getElementById('CORREO_ELECTRONICO').value;
        const SECTOR_CONTRIBUYENTE = document.getElementById('SECTOR_CONTRIBUYENTE').value;
        const RESPONSABLE_PAGO = document.getElementById('RESPONSABLE_PAGO').value;
        const TELEFONO_RESP_PAGO = document.getElementById('TELEFONO_RESP_PAGO').value;
        const ID_TIPO_FACTURACION = document.getElementById('ID_TIPO_FACTURACION').value;
        const TARIFA = document.getElementById('TARIFA').value;
        const ACUERDO_MCPAL = document.getElementById('ACUERDO_MCPAL').value;
        var errores = [];
        if (!NOMBRE) { errores.push("error_nombre"); }
        if (!NIT_CONTRIBUYENTE) { errores.push("error_nit"); }
        if (!ID_DEPARTAMENTO) { errores.push("error_id_departamento"); }
        if (!ID_MUNICIPIO) { errores.push("error_id_municipio"); }
        if (!DIRECCION_CONTRIBUYENTE) { errores.push("error_direccion"); }
        if (!CORREO_ELECTRONICO) { errores.push("error_correo"); }
        if (!SECTOR_CONTRIBUYENTE) { errores.push("error_sector"); }
        if (!RESPONSABLE_PAGO) { errores.push("error_respons"); }
        if (!TELEFONO_RESP_PAGO) { errores.push("error_telefono"); }
        if (!ID_TIPO_FACTURACION) { errores.push("error_tipfact"); }
        if (!TARIFA) { errores.push("error_tarifa"); }
        if (!ACUERDO_MCPAL) { errores.push("error_acuerdo"); }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(errores.length);
        Swal.showLoading();
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        authAxios.post("contribuyentes/editar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.close();
                Swal.fire(
                    'Contribuyentes!',
                    datosRespuesta.data.msj,
                    'success'
                )
                this.props.history.push("/MasterContribuyentes");
            })
            .catch(console.log)
    }
    departamentos() {
        authAxios.get("departamentos/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, departamentos: datosRespuesta.data.data, load: '' });
            })
            .catch(console.log);
    }
    municipios(dep, mun) {
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + dep)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, municipios: datosRespuesta.data, load: '' });
                document.getElementById("ID_MUNICIPIO").value = mun;
                window.$("#ID_MUNICIPIO").focus();
                Swal.close();
            })
            .catch(console.log);
    }
    cargardatos() {
        Swal.showLoading();
        authAxios.get("contribuyentes/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, arrayResultado: datosRespuesta.data, load: '' });
                //para llenar los select
                var dep = datosRespuesta.data.ID_DEPARTAMENTO;
                var mun = datosRespuesta.data.ID_MUNICIPIO;
                document.getElementById("ID_DEPARTAMENTO").value = dep;
                this.municipios(dep, mun);
            })
            .catch(console.log);
    }
    buscarmunicipios() {
        var dep = document.getElementById("ID_DEPARTAMENTO").value;
        this.municipios(dep, '');
    }
    componentDidMount() {
        this.departamentos();
        this.cargardatos();
    }
    render() {
        const { load, arrayResultado, departamentos, municipios } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>EDITAR CONTRIBUYENTE</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="NIT_CONTRIBUYENTE">NIT Contribuyente</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="NIT_CONTRIBUYENTE" id="NIT_CONTRIBUYENTE" defaultValue={arrayResultado.NIT_CONTRIBUYENTE}
                                                            className={((this.verificarError("error_nit")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="NIT" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el NIT</small>
                                                </div>
                                                <div className="col-md-10">
                                                    <input type="hidden" name="id" id="id" value={this.props.match.params.id} />
                                                    <label htmlFor="NOMBRE">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="NOMBRE" id="NOMBRE" defaultValue={arrayResultado.NOMBRE}
                                                        className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Nombre" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="ID_DEPARTAMENTO">Departamento</label>
                                                    <select name="ID_DEPARTAMENTO" id="ID_DEPARTAMENTO"
                                                        onChange={e => {
                                                            this.buscarmunicipios(e);
                                                            this.cambioValor(e)
                                                        }}
                                                        className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}>
                                                        <option value="">Seleccione el Departamento</option>
                                                        {
                                                            departamentos.map((itemDepartamentos) => (
                                                                <option key={itemDepartamentos.ID_DEPARTAMENTO} value={itemDepartamentos.ID_DEPARTAMENTO}>{itemDepartamentos.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="ID_MUNICIPIO">Municipio</label>
                                                    <select name="ID_MUNICIPIO" id="ID_MUNICIPIO"
                                                        className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el municipio</option>
                                                        {
                                                            municipios.map((item) => (
                                                                <option key={item.ID_MUNICIPIO} value={item.ID_MUNICIPIO}>{item.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="DIRECCION_CONTRIBUYENTE">Dirección</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="DIRECCION_CONTRIBUYENTE" id="DIRECCION_CONTRIBUYENTE" defaultValue={arrayResultado.DIRECCION_CONTRIBUYENTE}
                                                        className={((this.verificarError("error_direccion")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Dirección" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite la Dirección</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="CORREO_ELECTRONICO">Correo Electrónico</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="CORREO_ELECTRONICO" id="CORREO_ELECTRONICO" defaultValue={arrayResultado.CORREO_ELECTRONICO}
                                                            className={((this.verificarError("error_correo")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Correo Electrónico" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Correo Electrónico</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-12">
                                                    <label htmlFor="SECTOR_CONTRIBUYENTE">Sector</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="SECTOR_CONTRIBUYENTE" id="SECTOR_CONTRIBUYENTE" defaultValue={arrayResultado.SECTOR_CONTRIBUYENTE}
                                                        className={((this.verificarError("error_sector")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Sector" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite el Sector</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-9">
                                                    <label htmlFor="RESPONSABLE_PAGO">Responsable Pago</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="RESPONSABLE_PAGO" id="RESPONSABLE_PAGO" defaultValue={arrayResultado.RESPONSABLE_PAGO}
                                                        className={((this.verificarError("error_respons")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Responsable Pago" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite el Responsable Pago</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="TELEFONO_RESP_PAGO">Tel. Responsable Pago</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="TELEFONO_RESP_PAGO" id="TELEFONO_RESP_PAGO" defaultValue={arrayResultado.TELEFONO_RESP_PAGO}
                                                            className={((this.verificarError("error_telefono")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Tel. Responsable Pago" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Tel. Responsable Pago</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN TIPO FACTURACIÓN</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="ID_TIPO_FACTURACION">Tipo Facturación</label>
                                                    <select name="ID_TIPO_FACTURACION"
                                                        id="ID_TIPO_FACTURACION"
                                                        value={arrayResultado.ID_TIPO_FACTURACION}
                                                        options={arrayResultado.ID_TIPO_FACTURACION}
                                                        className={((this.verificarError("error_tipfact")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione Tipo Facturación</option>
                                                        <option value="1">CONSUMOS</option>
                                                        <option value="2">SALARIO</option>
                                                        <option value="3">UVT</option>
                                                        <option value="4">COMERCIAL</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo Facturación</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="TARIFA">Tarifa</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" name="TARIFA" id="TARIFA" defaultValue={arrayResultado.TARIFA}
                                                            className={((this.verificarError("error_tarifa")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Tarifa" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite la Tarifa</small>
                                                </div>
                                                <div className="col-md-7">
                                                    <label htmlFor="ACUERDO_MCPAL">Acuerdo Municipal</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="ACUERDO_MCPAL" id="ACUERDO_MCPAL" defaultValue={arrayResultado.ACUERDO_MCPAL}
                                                        className={((this.verificarError("error_acuerdo")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Acuerdo Municipal" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite el Acuerdo Municipal</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar Contribuyente</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterContribuyentes"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;